<template>
    <div class="cc-vouchers">
        <div class="cc-vouchers__header" v-if="!display && !showVoucherFieldByDefault">
            <div class="cc-title cc-title--vouchers" @click="toggleVoucher">{{ translations['I have a voucher'] }}</div>
        </div>
        <div class="cc-vouchers__controls" v-if="display || showVoucherFieldByDefault">
            <div class="cc-form-input">
                <input id="voucher.code" type="text" name="voucher.code" class="cc-input cc-input--text cc-input--with-button cc-input--small" size="15" v-model="code" @keyup.enter="applyVoucher" :placeholder="`${translations['Enter a voucher code']}`">
                <button class="cc-button cc-button--for-input cc-button--small" @click="applyVoucher">{{ translations['Add'] }}</button>
                <div v-if="!showVoucherFieldByDefault" class="cc-control cc-control--hide-voucher-input" @click="toggleVoucher">&times;</div>
                <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="error">{{ error }}</div>
            </div>
        </div>
        <div class="cc-vouchers__main">
            <voucher v-for="voucher in vouchers" v-bind:key="voucher.code" :voucher="voucher"/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Voucher from "./Voucher";

    export default {
        components: {
            Voucher,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                vouchers: state => state.voucher.vouchers,
                showVoucherFieldByDefault: state => state.config.show_voucher_field_by_default,
            }),
        },
        data: function () {
            return {
                display: false,
                code: '',
                error: '',
            };
        },
        methods: {
            toggleVoucher: function () {
                const display = !this.display;

                if (!display) {
                    this.error = '';
                    this.code = '';
                }

                this.display = display;
            },
            applyVoucher: function () {
                this.$store.dispatch('voucher/apply', this.code)
                    .then((data) => {
                        if (data.state === 'invalid') {
                            this.error = data.message;
                            return;
                        }

                        this.display = false;
                        this.error = '';
                        this.code = '';
                    });
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/vouchers";
</style>
